export const GETTERS_COHORTS = "GETTERS_COHORTS";
export const ACTIONS_GET_COHORTS = "ACTIONS_GET_COHORTS";
export const MUTATIONS_SET_COHORTS = "MUTATIONS_SET_COHORTS";
export const ACTIONS_ADD_COHORTS = "ACTIONS_ADD_COHORTS";
export const ACTIONS_REMOVE_COHORT = "ACTIONS_REMOVE_COHORT";
export const ACTIONS_REMOVE_COLLECTION = "ACTIONS_REMOVE_COLLECTION";
export const ACTIONS_GET_COLLECTIONS = "ACTIONS_GET_COLLECTIONS";
export const MUTATIONS_SET_COLLECTIONS = "MUTATIONS_SET_COLLECTIONS";
export const GETTERS_COLLECTIONS = "GETTERS_COLLECTIONS";
export const ACTIONS_GET_COLLECTIONS_BY_ID = "ACTIONS_GET_COLLECTIONS_BY_ID";

export const DATA_INPUT_TYPE = {
  BIOMETRIC: "BIOMETRIC_INPUT"
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_cohorts/constants.js